import { Injectable } from '@angular/core';

import { BehaviorSubject, finalize, Observable } from 'rxjs';
import { RequestMethod } from '../Enums/callerEnums';
import { DynamicObject, ResponseTypes } from '../interfaces/callerInterfaces';
import { BaseRequestHandlerService } from './base-request-handler.service';

@Injectable({
  providedIn: 'root',
})
export class ApiCallerService extends BaseRequestHandlerService {
  public isLoadingSubject: BehaviorSubject<boolean> =
  new BehaviorSubject<boolean>(false);
  public isLoading$: Observable<boolean> = this.isLoadingSubject.asObservable();

  setLoadingState(isLoading: boolean) {
    this.isLoadingSubject.next(isLoading);
  }
  constructor() {
    super();
  }

  public get<T>(
    url: string,
    queryPrams?: DynamicObject,
    responseType?: ResponseTypes,
    skipErrorHandeling: boolean = false
  ): Observable<T> {
    this.setLoadingState(true);
    return this.sendRequest<T>({
      method: RequestMethod.GET,
      url: url,
      prams: queryPrams,
      responseType,
      skipErrorHandeling,
    }).pipe(finalize(() => this.setLoadingState(false)));
  }

  public post(
    url: string,
    body: any,
    skipErrorHandeling: boolean = false
  ): Observable<any> {
    this.setLoadingState(true);
    return this.sendRequest({
      method: RequestMethod.POST,
      url: url,
      body: body,
      skipErrorHandeling,
    }).pipe(finalize(() => this.setLoadingState(false)));
  }

  public put(
    url: string,
    body: any,
    skipErrorHandeling: boolean = false
  ): Observable<any> {
    return this.sendRequest({
      method: RequestMethod.PUT,
      url: url,
      body: body,
      skipErrorHandeling,
    });
  }

  public delete(
    url: string,
    skipErrorHandeling: boolean = false
  ): Observable<any> {
    return this.sendRequest({
      method: RequestMethod.DELETE,
      url: url,
      skipErrorHandeling,
    });
  }
}
